/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Scandinavian_Studies26Inputs */

const en__field__enum_primarystudyinterest_study_scandinavian_studies26 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Scandinavian_Studies26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scandinavian Studies`)
};

const de__field__enum_primarystudyinterest_study_scandinavian_studies26 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Scandinavian_Studies26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skandinavistik`)
};

/**
* | output |
* | --- |
* | "Scandinavian Studies" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Scandinavian_Studies26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_scandinavian_studies26 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Scandinavian_Studies26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Scandinavian_Studies26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_scandinavian_studies26(inputs)
	return de__field__enum_primarystudyinterest_study_scandinavian_studies26(inputs)
});
export { _field__enum_primarystudyinterest_study_scandinavian_studies26 as "_field__enum_primaryStudyInterest_STUDY_SCANDINAVIAN_STUDIES" }